import { backendApi } from "../dynamicBAseQuery";

export const ClientReferencesApi = backendApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getReferalTableList: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `referalList`,
                body: { ...args }
            })
        }),

        clientReferalDropDown: builder.query({
            query: () => ({
                method: "GET",
                url: `clientReferalDropDown`
            })
        }),
        
        AddClientReferal: builder.mutation({
            query: (args) => ({
                method: "POST",
                url :`ClientReferal/Save`,
                body: {...args}
            }) 
        }),

        ViewClientReferalById: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `ViewClientReferalById`,
                body: {...args}
            })
        }),

        clientReferalApproval: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `clientReferalApproval`,
                body: {...args}
            })
        }),
    })
})

export const {
    useGetReferalTableListMutation,
    useClientReferalDropDownQuery,
    useAddClientReferalMutation,
    useViewClientReferalByIdMutation,
    useClientReferalApprovalMutation,
} = ClientReferencesApi